import {Col, Container, Row} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

import './styles.scss';

export const FestivalSection = () => {
    const navigate = useNavigate();
    
    // TODO: fix this
    // currently the Primary school version
    const signupPageId: number = 5944569048858624;

    return (
        <section className="festival-section">
            <Container fluid className="h-100 d-flex flex-column justify-content-center">
                <Row className="mb-4">
                    <Col md={{span: 10, offset: 1}}>
                        <h1 className="mb-4">The Young Eyes Festival of Innovation</h1>
                        <p>
                            The Young Eyes Festival of Innovation originated as an initiative of Zig Zag Hub – a
                            coworking conglomerate dedicated to meeting the needs of start-ups. Advances in
                            technology, changes in the nature of work and the number of aspiring young innovators
                            with the desire to create and instigate change, established an organic demand for
                            entrepreneurial learning. The Young Eyes Festival of Innovation emerged to fill such
                            void, through entrepreneurial education in schools.
                        </p>
                        <p>
                            The Young Eyes Festival of Innovation remains the keynote event staged by the Young
                            Eyes Team, where rising stars from the Illawarra, South Coast and beyond, are
                            presented with the opportunity and necessary support to bring their change making
                            ideas to reality.
                        </p>
                    </Col>
                </Row>

                <Row className="align-items-center mb-5">
                    <Col md={{span: 5, offset: 1}}>
                        <div className="festival-video-wrapper">
                            <iframe
                                src="https://www.youtube.com/embed/VcP7Np-JM-Q?si=HtenCcdYZmsEh2Mv"
                                title="Festival Video"
                                frameBorder="0"
                                allow="autoplay; encrypted-media"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </Col>
                    <Col md={5}>
                        <div className="festival-image-wrapper">
                            <img
                                src="/assets/images/LandingPage/FestivalSection/Participants.jpg"
                                alt="Festival participants"
                            />
                        </div>
                    </Col>
                </Row>

                <Row className="mb-4">
                    <Col md={{span: 10, offset: 1}}>
                        <h2 className="mb-4">It takes a spark of an idea to unleash a hidden passion</h2>
                        <p>
                            Is your child full of creative ideas? Then our Future Founders Program is for them. 
                            Designed for students aged 11 to 14, this fun and flexible online learning experience 
                            helps young minds explore entrepreneurial thinking, build confidence, and bring their 
                            ideas to life. 
                        </p>
                        <p>
                            Students who take part in the program will have the opportunity to pitch their idea at 
                            our ‘Shark Tank’ event in early September, with selected finalists going on to present 
                            at the 2025 Young Eyes Festival of Innovation. 
                        </p>
                    </Col>
                </Row>

                <Row className="mb-4">
                    <Col md={{span: 10, offset: 1}}>
                        <h2 className="mb-4">What is involved?</h2>
                        <p>
                            The Future Founders Program is made up of 5 fun-filled and engaging modules designed to 
                            spark creativity, build confidence, and develop key entrepreneurial skills. (The first 
                            2 modules are free!)
                        </p>
                        <ul>
                            <li>Each module is approximately 30 minutes and can be completed at your child’s own pace</li>
                            <li>
                                After completing all 5 modules, your child can apply to pitch their idea at our 
                                ‘Shark Tank’ event (held outside school hours in the first week of September)
                            </li>
                            <li>
                                Finalists from the Shark Tank event will be invited to present at our major event — 
                                The Young Eyes Festival of Innovation on September 24th at the HARS Aviation Museum 
                                (participation optional)
                            </li>
                            <li>
                                At the Festival, winners will be awarded titles of ‘Young Entrepreneur of the Year’ and 
                                ‘Young Innovator of the Year’. Winners will also receive $500 in prize money and access 
                                to an exclusive mentoring workshop.
                            </li>
                            <li><b>Program Fee:</b> $29.95</li>
                            <li><b>Applications close:</b> Saturday, August 23rd at 5pm</li>
                            <li><b>Age Group:</b> 11 to 14 years</li>
                        </ul>
                        <div className="button-wrapper">
                            <button onClick={() => navigate(`/join/public/${signupPageId}`)} className="buy-now-button">Try the first two modules free <FontAwesomeIcon icon={faArrowAltCircleRight} size="lg" /></button>
                        </div>
                    </Col>
                </Row>
                {/* <Row className="sponsors-row mt-3 text-center">
                    <Col xs={4} md={4} className="sponsor-tier">
                        <h3>Major Sponsor</h3>
                        <div className="sponsor-logos">
                            <img
                                src="/assets/images/LandingPage/FestivalSection/Sicona-logo.png"
                                alt="Major Sponsor"
                                className="sponsor-logo"
                                width="140px"
                            />
                        </div>
                    </Col>
                    <Col xs={4} md={4} className="sponsor-tier">
                        <h3>Silver Sponsor</h3>
                        <div className="sponsor-logos">
                            <img
                                src="/assets/images/sponsors/silver-1.png"
                                alt="Silver Sponsor"
                                className="sponsor-logo"
                            />
                        </div>
                    </Col>
                    <Col xs={4} md={4} className="sponsor-tier">
                        <h3>Bronze Sponsor</h3>
                        <div className="sponsor-logos">
                            <img
                                src="/assets/images/LandingPage/FestivalSection/Foye-Legal-logo.svg"
                                alt="Bronze Sponsor"
                                className="sponsor-logo"
                                width="120px"
                            />
                        </div>
                    </Col>
                </Row> */}
            </Container>
        </section>
    );
};